import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { asyncScheduler, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Buttoms, DefaultListOrder } from '../../../../private/shared/models/order-list';
import { IProductos, IPromosEcommerce, ISummaryPrice } from './../../../../private/shared/models/productos';
import { ILimitsToast } from './../../../models/ApplicationUser';
import { SummaryPriceDefault } from './../../../models/Constants';
import { OperationsService } from './../../../services/operations/operations.service';
import { ToastControllerService } from './../../../services/toast-controller.service';

@Component({
  selector: 'how-many-redeem',
  templateUrl: './how-many-redeem.component.html',
  styleUrls: ['./how-many-redeem.component.scss'],
})
export class HowManyRedeemComponent implements OnInit, OnChanges, OnDestroy {

  @Input() max = 0;
  @Input() initial = 0;
  @Input() exchange = 0;
  @Input() isCount = false;
  @Input() tipoPromocion = '';
  @Input() promosCart: IPromosEcommerce = {} as IPromosEcommerce;
  @Input() productosPromocion: IProductos[] = []
  @Input() isBonus = true;

  @Output() addExchange = new EventEmitter<number>();

  public rangeInput: Buttoms = DefaultListOrder.componentContent.range.buttoms;
  public equal = '';
  public resetRange = false;

  private LimitMaxCajas = 0;
  private LimitMaxMonto = 0;
  private summaryPrice: ISummaryPrice = SummaryPriceDefault;
  private finishSubscriptions: Subject<boolean> = new Subject();

  constructor(
    private operationsS: OperationsService
    , private toastS: ToastControllerService
    , private translate: TranslateService
  ) { }

  async ngOnInit() {
    this.LimitMaxCajas = this.operationsS.LimitMaxCajas || 0;
    this.LimitMaxMonto = this.operationsS.LimitMaxMonto || 0;
    this.equal = this.translate.instant('Labels.equal');

    this.operationsS.summaryPriceTotal$()
      .pipe(
        takeUntil(this.finishSubscriptions)
      )
      .subscribe(summaryPrice => this.summaryPrice = summaryPrice);
  }

  ngOnDestroy(): void {
    this.finishSubscriptions.next(true);
    this.finishSubscriptions.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    // Calcula el maximo de rango por producto
    const end = changes.hasOwnProperty('maxRange') ? changes.max.currentValue : this.max;
    const initial = changes.hasOwnProperty('initial') ? changes.initial.currentValue : this.initial;
    this.rangeInput = { ...this.rangeInput, end, initial };
  }

  public comeBack = async (select: number) => {
    // * Validación de precio maximo
    const cartProductsPrice = this.productosPromocion.map(p => (p.precio || 0) * (p.productos || 0) * this.promosCart.PaquetesCanjeados).reduce((a, b) => a + b);
    const productsPrice = this.productosPromocion.map(p => (p.precio || 0) * (p.productos || 0) * select).reduce((a, b) => a + b);
    const totalPrice = this.summaryPrice.total_precio - cartProductsPrice;
    const priceSelected = productsPrice + totalPrice;
    if (this.LimitMaxMonto > 0 && priceSelected > this.LimitMaxMonto) {
      await this.toastS.dismissToast();
      const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-prices');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxMonto.toString()), color, icon, duration, clase, position, header);
      this.resetRange = true;
      asyncScheduler.schedule(() => this.resetRange = false, 50);
      return;
    }

    // * Validación de cajas maximo
    const cartProductsBoxs = this.productosPromocion.map(p => ((p.FactorCl || 0) * (p.productos || 0)) * this.promosCart.PaquetesCanjeados).reduce((a, b) => a + b);
    const productsBoxs = this.productosPromocion.map(p => ((p.FactorCl || 0) * (p.productos || 0)) * select).reduce((a, b) => a + b);
    const totalCajas = ((this.summaryPrice.FactorCl || 0) - cartProductsBoxs) + productsBoxs;
    if (this.LimitMaxCajas > 0 && totalCajas > this.LimitMaxCajas) {
      await this.toastS.dismissToast();
      const { header, message, color, icon, duration, clase, position }: ILimitsToast = this.translate.instant('Toasts.limits-boxs');
      this.toastS.presentToast(message.replace('{{limit}}', this.LimitMaxCajas.toString()), color, icon, duration, clase, position, header);
      this.resetRange = true;
      asyncScheduler.schedule(() => this.resetRange = false, 50);
      return;
    }

    this.addExchange.emit(select);
  }

}
